const baseUrl = '/IPP';

const accountsBasePrefix = `${baseUrl}/accounts`;
export const accounts = {
  getCustomer: (customerId: string) => `${accountsBasePrefix}/customer/${customerId}`,
  getAccountDetails: (accountCode: string) => `${accountsBasePrefix}/details/${accountCode}`,
  getCreditLimit: (accountId: string) => `${accountsBasePrefix}/credit-limit/${accountId}`,
  postCreditLimit: () => `${accountsBasePrefix}/credit-limit`,
  getCreditLimitRequests: (accountId: string) => `${accountsBasePrefix}/credit-limit/${accountId}/requests`,
  approveCreditLimitRequest: (requestId: string) => `${accountsBasePrefix}/credit-limit/approve/${requestId}`,
  rejectCreditLimitRequest: (requestId: string) => `${accountsBasePrefix}/credit-limit/reject/${requestId}`,
  getCreditLimitFile: (requestId: string) => `${accountsBasePrefix}/credit-limit/file/${requestId}`,
  uploadCreditLimitFile: (requestId: string) => `${accountsBasePrefix}/credit-form/file${requestId}`,
  partnerAccountNumber: () => `${accountsBasePrefix}/partner-account`,
  getCreditPdf: () => '/credit/pdf',
};

const searchBasePrefix = `${baseUrl}/search`;
const applicationsBasePrefix = `${baseUrl}/applications`;
const manualApplicationsBasePrefix = `${baseUrl}/manual-applications`;
export const applications = {
  getApplications: () => `${searchBasePrefix}/applications`,
  getApplication: () => `${searchBasePrefix}/applications`,
  getSupplementApplication: (applicationId: string) => `${applicationsBasePrefix}/supplementary/${applicationId}`,
  getMainApplication: (applicationId: string) => `${applicationsBasePrefix}/main/${applicationId}`,
  getManualApplication: () => '/IPP/search/manual/applications',
  pdf: () => `${applicationsBasePrefix}/pdf`,
  saveSupplement: () => `${applicationsBasePrefix}/supplementary`,
  saveApplication: () => applicationsBasePrefix,
  approveCreditLimit: (applicationId: string) => `${applicationsBasePrefix}/approveCreditLimit/${applicationId}`,
  rejectCreditLimit: (applicationId: string) => `${applicationsBasePrefix}/rejectCreditLimit/${applicationId}`,
  submitApplication: (applicationId: string) => `${applicationsBasePrefix}/submit/${applicationId}`,
  rejectApplication: (applicationId: string) => `${applicationsBasePrefix}/reject/${applicationId}`,
  assignApplication: (applicationId: string) => `${applicationsBasePrefix}/assign/${applicationId}`,
  assignManualApplication: () => `${manualApplicationsBasePrefix}/assign`,
  rejectManualApplicationFile: (fileId: string) => `${manualApplicationsBasePrefix}/file/reject/${fileId}`,
  submitManualApplication: () => `${manualApplicationsBasePrefix}/submit`,
  completeManualApplication: () => `${manualApplicationsBasePrefix}/complete`,
  rejectManualApplication: () => `${manualApplicationsBasePrefix}/reject`,
};

const authBasePrefix = '/auth';
export const auth = {
  authenticate: (userId: string) => `${authBasePrefix}/token/${userId}/IPP`,
  refreshToken: (refreshToken: string) => `${authBasePrefix}/refresh/${refreshToken}/IPP`,
  onbehalf: (userId: string) => `${authBasePrefix}/onbehalf/${userId}`,
};

const cardBasePrefix = `${baseUrl}/cards`;
export const cards = {
  getAccount: (accountId: string) => `${cardBasePrefix}/account/${accountId}`,
  activation: (cardId: string) => `${cardBasePrefix}/activation/${cardId}`,
  replaceCard: (cardId: string) => `${cardBasePrefix}/replace/${cardId}`,
  reprintPin: (cardId: string) => `${cardBasePrefix}/reprint-pin/${cardId}`,
  blockCard: (cardId: string) => `${cardBasePrefix}/block/${cardId}`,
  unblockCard: (cardId: string) => `${cardBasePrefix}/unblock/${cardId}`,
};

const customerBasePrefix = `${baseUrl}/customers`;
export const customers = {
  getCustomers: () => `${searchBasePrefix}/customers`,
  getCustomerCard: (customerId: string) => `${customerBasePrefix}/${customerId}`,
};

const dictionariesBasePrefix = `${baseUrl}/dictionaries`;
export const dictionaries = {
  getCountries: () => `${dictionariesBasePrefix}/countries`,
  getNationalities: () => `${dictionariesBasePrefix}/nationalities`,
  getEconomicActivities: () => `${dictionariesBasePrefix}/economic-activities`,
};

const fileBasePrefix = `${baseUrl}/files`;
export const files = {
  getTypes: () => `${fileBasePrefix}/types`,
  getApplicationFiles: (applicationId: string) => `${fileBasePrefix}/application/${applicationId}`,
  downloadFile: (fileId: string) => `${fileBasePrefix}/download/${fileId}`,
  uploadFile: () => fileBasePrefix,
  deleteFile: (fileId: string) => `${fileBasePrefix}/${fileId}`,
};

const messagesBasePrefix = `${baseUrl}/messages`;
export const messages = {
  getThreads: () => `${messagesBasePrefix}/threads`,
  getThread: (threadId: string) => `${messagesBasePrefix}/threads/${threadId}`,
  postMessage: () => messagesBasePrefix,
  readMessage: () => `${messagesBasePrefix}/read`,
  deleteMessage: (groupId: string) => `${messagesBasePrefix}/${groupId}`,
  postAttachment: (messageId: string) => `${messagesBasePrefix}/${messageId}/attachments`,
  downloadAttachment: (messageId: string, fileId: string) => `${messagesBasePrefix}/${messageId}/attachments/${fileId}`,
};

const productsBasePrefix = `${baseUrl}/products`;
export const products = {
  getPartners: () => `${productsBasePrefix}/partners`,
  getProducts: () => productsBasePrefix,
};

const resourcesBasePrefix = `${baseUrl}/resources`;
export const resources = {
  getRepository: () => `${resourcesBasePrefix}/repository`,
  download: (id: string) => `${resourcesBasePrefix}/download/${id}`,
};

const statementsBasePrefix = `${baseUrl}/statements`;
export const statements = {
  getStatements: () => `${statementsBasePrefix}/search`,
  downloadStatement: () => `${statementsBasePrefix}/download`,
};

const transactionsBasePrefix = `${baseUrl}/transactions`;
export const transactions = {
  getTransactions: () => transactionsBasePrefix,
};

const usersBasePrefix = `${baseUrl}/users`;
export const users = {
  getUsers: () => usersBasePrefix,
};
